import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      data: null,
      dialog: false,
      loading: false,
      alert: false,
      loadingDeny: false,
      moment,
      dayTranslations: {
        DOMINGO: "Domingo",
        SEGUNDA_FEIRA: "Segunda-feira",
        TERCA_FEIRA: "Terça-feira",
        QUARTA_FEIRA: "Quarta-feira",
        QUINTA_FEIRA: "Quinta-feira",
        SEXTA_FEIRA: "Sexta-feira",
        SABADO: "Sábado"
      }
    };
  },

  methods: {
    hasSchedule(key) {
      const schedule =
        this.data &&
        this.data.consent &&
        this.data.consent.payment &&
        this.data.consent.payment.schedule;
      return schedule && Object.prototype.hasOwnProperty.call(schedule, key);
    },

    formateDate(data) {
      if (!data) return "";

      let date = "";

      if (data.schedule) {
        if ("daily" in data.schedule) {
          date = data.schedule.daily.startDate.split("-");
        } else if ("weekly" in data.schedule) {
          date = data.schedule.weekly.startDate.split("-");
        } else if ("monthly" in data.schedule) {
          date = data.schedule.monthly.startDate.split("-");
        } else if ("single" in data.schedule) {
          date = data.schedule.single.date.split("-");
        } else {
          console.log("Custom!");
          return "";
        }
        return `${date[2]}/${date[1]}/${date[0]}`;
      } else if (data.date) {
        date = data.date.split("-");
        return `${date[2]}/${date[1]}/${date[0]}`;
      }

      return "";
    },

    async approveConsent() {
      this.loading = true;
      const body = {
        consentInteractionId: this.data.interactionId,
        debtorAccount: {
          ispb: "12345678",
          issuer: "0001",
          number: "969139",
          accountType: "CACC"
        }
      };
      try {
        const response = await axios.post(
          `api/${process.env.VUE_APP_ORG_NAME}/consents/v1/interactions/consent`,
          body
        );
        window.open(response.data, "_self");
      } catch (error) {
        console.log(error);
        this.alert = true;
      } finally {
        this.loading = false;
      }
    },

    async cancelConsent() {
      this.loadingDeny = true;
      const body = { consentInteractionId: this.data.interactionId };
      try {
        const response = await axios.post(
          `api/${process.env.VUE_APP_ORG_NAME}/consents/v1/interactions/cancel`,
          body
        );
        this.dialog = false;
        window.open(response.data, "_self");
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingDeny = false;
      }
    }
  },

  computed: {
    formatCpf() {
      const badchars = /[^\d]/g;
      const mask = /(\d{3})(\d{3})(\d{3})(\d{2})/;
      const cpf = String(this.data.consent.creditor.cpfCnpj).replace(
        badchars,
        ""
      );
      return cpf.replace(mask, "$1.$2.$3-$4");
    },

    formatCnpj() {
      const badchars = /[^\d]/g;
      const mask = /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/;
      const cnpj = String(this.data.consent.creditor.cpfCnpj).replace(
        badchars,
        ""
      );
      return cnpj.replace(mask, "$1.$2.$3/$4-$5");
    }
  },

  beforeMount() {
    this.data = this.$route.params.data;
    if (!this.data) {
      this.$router.push({ path: "/" });
    }
  }
};
